"use client";
import {
  useDialogStore
} from "../__chunks/BM6PGYQY.js";
import "../__chunks/WYCIER3C.js";
import {
  DialogContextProvider
} from "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/dialog/dialog-provider.tsx
import { jsx } from "react/jsx-runtime";
function DialogProvider(props = {}) {
  const store = useDialogStore(props);
  return /* @__PURE__ */ jsx(DialogContextProvider, { value: store, children: props.children });
}
export {
  DialogProvider
};
